import { WebPlugin } from '@capacitor/core';
export class NativeGeocoderWeb extends WebPlugin {
    constructor() {
        super({
            name: 'NativeGeocoder',
            platforms: ['web'],
        });
    }
    // @ts-ignore
    reverseGeocode(reverseGeocodeOptions) {
        throw new Error("Method not implemented.");
    }
    // @ts-ignore
    forwardGeocode(forwardGeocodeOptions) {
        throw new Error("Method not implemented.");
    }
}
const NativeGeocoder = new NativeGeocoderWeb();
export { NativeGeocoder };
import { registerWebPlugin } from '@capacitor/core';
registerWebPlugin(NativeGeocoder);
//# sourceMappingURL=web.js.map